import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var amber = {
  amber01: '#230F00',
  amber02: '#331701',
  amber03: '#441F05',
  amber04: '#53270B',
  amber05: '#612D10',
  amber06: '#703414',
  amber07: '#803A18',
  amber08: '#90421C',
  amber09: '#A14921',
  amber10: '#B35126',
  amber11: '#C5592B',
  amber12: '#D96432',
  amber13: '#E8723D',
  amber14: '#EE8846',
  amber15: '#F39D4D',
  amber16: '#F8B256',
  amber17: '#FFCC60',
  amber18: '#FED680',
  amber19: '#FEE3A9',
  amber20: '#FEEDC8',
  amber21: '#FEF7E7'
};
export var blue = {
  blue01: '#01132F',
  blue02: '#001C49',
  blue03: '#002560',
  blue04: '#002E75',
  blue05: '#00368A',
  blue06: '#003DA1',
  blue07: '#0146B5',
  blue08: '#034FCA',
  blue09: '#0A5ADA',
  blue10: '#1E6DEB',
  blue11: '#1D74F5',
  blue12: '#3883FA',
  blue13: '#5093FD',
  blue14: '#69A2FE',
  blue15: '#83B2FE',
  blue16: '#9BC1FE',
  blue17: '#B2CFFE',
  blue18: '#C8DCFE',
  blue19: '#D9E7FE',
  blue20: '#E6EFFE',
  blue21: '#F5F8FF'
};
export var gray = {
  gray01: '#10141C',
  gray02: '#1A1E2B',
  gray03: '#242938',
  gray04: '#292E3E',
  gray05: '#363B51',
  gray06: '#3E445C',
  gray07: '#434A63',
  gray08: '#4F5875',
  gray09: '#576283',
  gray10: '#616D92',
  gray11: '#6E799E',
  gray12: '#7A86A9',
  gray13: '#8893B7',
  gray14: '#98A2C3',
  gray15: '#A9B1CC',
  gray16: '#B9BFD5',
  gray17: '#C8CDE0',
  gray18: '#D7DAE8',
  gray19: '#E3E6F2',
  gray20: '#EAEEF7',
  gray21: '#F6F8FE'
};
export var green = {
  green01: '#011714',
  green02: '#03241E',
  green03: '#032F28',
  green04: '#053A30',
  green05: '#064439',
  green06: '#074E42',
  green07: '#08594B',
  green08: '#086455',
  green09: '#086F5F',
  green10: '#087C69',
  green11: '#098972',
  green12: '#0A987E',
  green13: '#16A68C',
  green14: '#3FB5A0',
  green15: '#58C2AF',
  green16: '#72D0C0',
  green17: '#96DBCE',
  green18: '#B0E5DC',
  green19: '#CAEDE7',
  green20: '#DFF3F0',
  green21: '#F1FAF8'
};
export var red = {
  red01: '#270A12',
  red02: '#3C0E1A',
  red03: '#511022',
  red04: '#631228',
  red05: '#76132D',
  red06: '#891433',
  red07: '#9A163A',
  red08: '#AC1940',
  red09: '#C01C48',
  red10: '#D32252',
  red11: '#E33161',
  red12: '#FA3E70',
  red13: '#FA5C86',
  red14: '#FB789B',
  red15: '#FC91AD',
  red16: '#FCA8BE',
  red17: '#FDBCCE',
  red18: '#FDCFDB',
  red19: '#FDDEE7',
  red20: '#FEE8EE',
  red21: '#FEF6F8'
};
export var violet = {
  violet01: '#1E0C28',
  violet02: '#300F42',
  violet03: '#411159',
  violet04: '#4E156C',
  violet05: '#5D197E',
  violet06: '#69208E',
  violet07: '#74289D',
  violet08: '#8230AE',
  violet09: '#8E3BBB',
  violet10: '#9B47C7',
  violet11: '#AA51D9',
  violet12: '#BB5FEC',
  violet13: '#C371EE',
  violet14: '#CB86F0',
  violet15: '#D49BF3',
  violet16: '#DFADFA',
  violet17: '#E7C0FB',
  violet18: '#ECD2FA',
  violet19: '#F1DEFD',
  violet20: '#F6E9FD',
  violet21: '#FBF6FE'
};
export var white = '#FFFFFF';
export var black = '#000000';
export var palette = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, amber), blue), green), red), violet), gray), {}, {
  white: white,
  black: black
});